import axios from 'axios';
import { default401 } from './auth';
import { store } from '../store';

const { site } = store.getState().theme;

export default () => axios({
  url: `${process.env.REACT_APP_MMB_API_URL}/api/utils/carriers/`,
  params: { site },
}).then(({ data }) => {
  store.dispatch({ type: 'LOAD_CARRIERS', payload: data });
}).catch(default401);
